import { actions } from "../../utils/constants";

const initialState = {
  loading: false,
  patientdata: [],
  patient_filters: {},
};
const PatientReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_PATIENT_LOADING:
      return { ...state, loading: true, patientdata: [] };
    case actions.SET_PATIENT_DATA:
      console.log("Updated Patient Data:", action.value.data);
      return {
        ...state,
        loading: false,
        patientdata: action.value.data,
        patient_filters: action.value.filters,
      };
    default:
      return { ...state };
  }
};
export default PatientReducer;
